import React from 'react';

/**
 * Extracts plain text from an HTML string for comparison purposes only.
 * Uses DOM textContent — not intended as a security sanitizer for display.
 */
export function stripHtml(html) {
  if (!html) return '';
  const el = document.createElement('div');
  el.innerHTML = html;
  return (el.textContent || '').trim();
}

/**
 * Returns true if a Quill-produced value is effectively empty.
 */
export function isEmptyRichText(value) {
  if (!value) return true;
  const stripped = stripHtml(value);
  return stripped === '' || value === '<p><br></p>';
}

/**
 * RichText – renders HTML content safely, or plain text if no HTML detected.
 * Provides backward compatibility between old plain-text data and new HTML data.
 *
 * @param {string} value  - Plain text or HTML string
 * @param {string} className  - Optional CSS class
 * @param {string} as  - HTML tag to use as wrapper (default 'span')
 */
export function RichText({ value, className = '', as: Tag = 'span' }) {
  if (!value) return null;
  const isHtml = /<[a-z][\s\S]*>/i.test(value);
  if (isHtml) {
    return (
      <Tag
        className={`rich-text-content ${className}`.trim()}
        dangerouslySetInnerHTML={{ __html: value }}
      />
    );
  }
  return <Tag className={className || undefined}>{value}</Tag>;
}
